// Redirections des pages de l'app (ex-proxy Next) : `null` laisse passer.
import { loginPath } from "@shared/client/session";
import type { SessionInfo } from "@shared/lib/auth-shared";

type Location = { pathname: string; search: string };

/** /app/* : connecté et onboarding terminé. */
export function productRule(session: SessionInfo | null, location: Location) {
  if (!session) return loginPath(location);
  return session.onboarded ? null : "/onboarding";
}

/** /onboarding : connecté, onboarding pas encore fait. */
export function onboardingRule(session: SessionInfo | null, location: Location) {
  if (!session) return loginPath(location);
  return session.onboarded ? "/app" : null;
}

/** Connexion et inscription : réservées aux visiteurs non connectés. */
export function guestRule(session: SessionInfo | null) {
  if (!session) return null;
  return session.onboarded ? "/app" : "/onboarding";
}
